<script lang="ts">
	import type { GapSize } from '../types';
	import PageGrid from '../components/pageGrid.svelte';
	import DivWrapper from '../components/divWrapper.svelte';
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			mobile_direction: string;
			desktop_direction: string;
			desktop_gap: GapSize;
			mobile_gap: GapSize;
			body: ISbStoryData[];
			page_margin: boolean;
			alignment: 'start' | 'center' | 'end';
			dont_fill_hide: boolean;
		}>['content'];
	}

	let { content }: Props = $props();

	let WrapperType = $derived(content.page_margin ? PageGrid : DivWrapper);
</script>

<div class:h-full={!content.dont_fill_hide} use:editable={content}>
	<WrapperType class={WrapperType === DivWrapper ? 'h-full' : ''}>
		<div
			class="flex h-full flex-{content.mobile_direction ||
				'col'} lg:flex-{content.desktop_direction || 'col'}"
			class:gap-[12px]={content.mobile_gap === 'xs'}
			class:gap-[20px]={content.mobile_gap === 'small'}
			class:gap-[32px]={content.mobile_gap === 'medium'}
			class:gap-[48px]={content.mobile_gap === 'large'}
			class:lg:gap-[12px]={content.desktop_gap === 'xs'}
			class:lg:gap-[20px]={content.desktop_gap === 'small'}
			class:lg:gap-[32px]={content.desktop_gap === 'medium'}
			class:lg:gap-[80px]={content.desktop_gap === 'large'}
			class:col-span-full={content.page_margin}
			class:justify-center={content.alignment === 'center'}
			class:justify-end={content.alignment === 'end'}
		>
			{#each content.body || [] as block}
				<Blok content={block} />
			{/each}
		</div>
	</WrapperType>
</div>
